/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import css from 'assets/scss/tryFeature.module.scss';
import 'lazysizes';
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Link from 'next/link';
import { Button, Hidden, Grid, Typography, useTheme } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { extensionLinks } from 'config/constants';
import { getQueryParams } from '@Common/handlers/helper';
import Track from '../../handlers/track';

const useStyles = makeStyles((theme) => ({
  btnText: {
    color: `${theme.palette.text.primary} !important`,
  },

  containerBoxEven: {
    // backgroundColor: theme.palette.background.paper,
  },
  containerBoxOdd: {
    backgroundColor: theme.palette.background.default,
  },
}));

const TryFeature = (props: { homeEnable?: boolean }) => {
  const classes = useStyles();
  const selectClickHandler = (value: 'chrome' | 'docs' | 'word') => {
    Track.extensionLinkClicked(value, 'extensionSection');

    if (value === 'chrome') {
      window.open(`${extensionLinks.chrome}${getQueryParams('extensionSection')}`, '_blank');
    } else window.open(extensionLinks[value], '_blank');
  };
  const theme = useTheme();
  return (
    <>
      <div
        className={` ${css.featureHolder} ${css.featureHolderFrist} ${classes.containerBoxEven}`}
      >
        <div
          className={`${css.bluecercle} ${css.container}`}
          style={{ backgroundImage: "url('./images/landinPage/bluecercle.svg')" }}
        >
          <Grid container className={`${css.flexFlip}`}>
            <Grid item xs={12} lg={7} md={7} sm={12}>
              <img
                // class="lazyload"
                // data-src="image.jpg"
                data-src="./images/landinPage/synonymNew.gif"
                className={` ${css.featureImg} lazyload`}
                alt="Synonyms"
              />
              {props.homeEnable && (
                <Hidden only={['md', 'lg', 'xl']}>
                  <div className={` ${css.contentBox}`}>
                    <Link href="/">
                      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
                      <a
                        role="link"
                        tabIndex={0}
                        className={`${css.featureLink}`}
                        onClick={() => Track.homePageBtnClick('wordFlipperSection')}
                      >
                        Try the Synonyms <ChevronRightIcon />
                      </a>
                    </Link>
                  </div>
                </Hidden>
              )}
            </Grid>
            <Grid item xs={12} lg={5} md={5} sm={12}>
              <div className={`${css.contentBox} ${css.rightTextBox}`}>
                <Typography variant="caption" component="span" color="primary">
                  customizations
                </Typography>
                <Typography variant="h3">Vocabulary enhancements</Typography>
                <p>Use the Synonyms to change more (or less) of your writing.</p>
                {props.homeEnable && (
                  <Hidden only={['xs', 'sm']}>
                    <Link href="/">
                      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
                      <a
                        className={`${css.featureLink}`}
                        role="link"
                        tabIndex={0}
                        onClick={() => Track.homePageBtnClick('wordFlipperSection')}
                      >
                        Try the Synonyms <ChevronRightIcon />
                      </a>
                    </Link>
                  </Hidden>
                )}
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
      {/*
      <div className={` ${css.featureHolder}  ${css.lightRedBg} `}>
        <div
          className={`${css.orangecercle} ${css.container}  `}
          style={{ backgroundImage: "url('./images/landinPage/orangecercle.svg')" }}>
          <Grid container>
            <Grid item xs={12} lg={5} md={5} sm={12}>
              <div className={` ${css.contentBox} ${css.leftTextBox} `}>
                <span>ARTIFICIAL INTELLIGENCE</span>
                <Typography variant="h3">Enhance clarity and meaning</Typography>
                <p>
                  Our writing modes help you paraphrase the way you want. Whether it’s grammar,
                  brevity, or creativity, you’ll get the results you need instantly.
                </p>
                {props.homeEnable && (
                  <Hidden only={['xs', 'sm']}>
                    <Link href="/">
                      <a
                        className={`${css.featureLink}`}
                        role="link"
                        tabIndex={0}
                        onClick={() => Track.homePageBtnClick('modeSection')}>
                        Try the AI modes <ChevronRightIcon />
                      </a>
                    </Link>
                  </Hidden>
                )}
              </div>
            </Grid>
            <Grid item xs={12} lg={7} md={7} sm={12}>
              <img
                // loading="lazy"
                data-src="./images/landinPage/artificial.gif"
                className={` ${css.featureImg} lazyload`}
                alt="paraphrasing modes"
              />
              {props.homeEnable && (
                <Hidden only={['md', 'lg', 'xl']}>
                  <div className={` ${css.contentBox}`}>
                    <Link href="/">
                      <a
                        className={`${css.featureLink}`}
                        role="link"
                        tabIndex={0}
                        onClick={() => Track.homePageBtnClick('modeSection')}>
                        Try the AI modes <ChevronRightIcon />
                      </a>
                    </Link>
                  </div>
                </Hidden>
              )}
            </Grid>
          </Grid>
        </div>
      </div> */}

      <div
        // className={`${css.lightBlueBg} ${css.featureHolder} ${css.greencercle} ${classes.containerBoxOdd}`}
        className={` ${css.featureHolder} ${css.greencercle} ${classes.containerBoxOdd}`}
        style={{
          backgroundImage: `url('./images/theme/${theme.palette.mode}/paraphraser/greenCircle.svg')`,
        }}
      >
        <div className={`${css.container}  `}>
          <Grid container>
            <Grid item xs={12} lg={5} md={5} sm={12}>
              <div className={`${css.contentBox} ${css.leftTextBox}`}>
                <Typography variant="caption" component="span" color="primary">
                  AI-Powered Thesaurus
                </Typography>
                <Typography variant="h3">Find the right synonym</Typography>
                <p>
                  Click on any word in your writing to find the right synonyms and get your perfect
                  word!
                </p>
                {props.homeEnable && (
                  <Hidden only={['xs', 'sm']}>
                    <Link href="/">
                      <a
                        className={`${css.featureLink}`}
                        role="link"
                        tabIndex={0}
                        onClick={() => Track.homePageBtnClick('thesaurusSection')}
                      >
                        Try the Thesaurus <ChevronRightIcon />
                      </a>
                    </Link>
                  </Hidden>
                )}
              </div>
            </Grid>
            <Grid item xs={12} lg={7} md={7} sm={12}>
              <img
                data-src="./images/landinPage/synonymImg.gif"
                className={` ${css.featureImg} lazyload`}
                alt="thesaurus"
                // loading="lazy"
              />
              {props.homeEnable && (
                <Hidden only={['md', 'lg', 'xl']}>
                  <div className={` ${css.contentBox}`}>
                    <Link href="/">
                      <a
                        className={`${css.featureLink}`}
                        role="link"
                        tabIndex={0}
                        onClick={() => Track.homePageBtnClick('thesaurusSection')}
                      >
                        Try the Thesaurus <ChevronRightIcon />
                      </a>
                    </Link>
                  </div>
                </Hidden>
              )}
            </Grid>
          </Grid>
        </div>
      </div>

      <div className={`${css.featureHolder} ${classes.containerBoxEven}`}>
        <div className={`${css.container}`}>
          <Grid container className={`${css.flexFlip}`}>
            <Grid item xs={12} lg={7} md={7} sm={12}>
              <img
                // loading="lazy"
                data-src="./images/landinPage/integrationsNew.gif"
                alt="extensions"
                className={` ${css.featureImg} lazyload`}
                style={{ maxHeight: '396px' }}
              />
              <Hidden only={['md', 'lg', 'xl']}>
                <div className={` ${css.contentBox}`}>
                  <Button
                    className={` ${css.extBox} ${classes.btnText} `}
                    onClick={() => selectClickHandler('word')}
                    variant="outlined"
                    color="primary"
                  >
                    <img loading="lazy" src="/images/welcomePage/wordIcon.svg" alt="modes" />
                    Add to Word
                  </Button>

                  <Button
                    onClick={() => selectClickHandler('chrome')}
                    className={` ${css.extBox} ${css.extBox2}  ${classes.btnText}`}
                    variant="outlined"
                    color="primary"
                  >
                    <img
                      loading="lazy"
                      src="/images/theme/commonImages/chrome.png"
                      alt="chrome icon"
                    />
                    Add to Chrome
                  </Button>
                  <Button
                    onClick={() => selectClickHandler('docs')}
                    className={` ${css.extBox}  ${classes.btnText} `}
                    variant="outlined"
                    color="primary"
                  >
                    <img loading="lazy" src="/images/google-docs-icon.svg" alt="google docs icon" />
                    Add to Docs
                  </Button>
                </div>
              </Hidden>
            </Grid>
            <Grid item xs={12} lg={5} md={5} sm={12}>
              <div className={`${css.contentBox} ${css.rightTextBox}`}>
                <Typography variant="caption" component="span" color="primary">
                  INTEGRATIONS
                </Typography>
                <Typography variant="h3">Plugs into the writing tools you already use</Typography>
                <p>
                  QuillBot integrates directly into Chrome and Microsoft Word. Now you don’t have to
                  switch windows every time you want to rephrase a sentence, paragraph, or article!
                </p>
                <Hidden only={['xs', 'sm']}>
                  <div>
                    <Button
                      className={` ${css.extBox} ${classes.btnText} `}
                      onClick={() => selectClickHandler('word')}
                      variant="outlined"
                      color="primary"
                    >
                      <img src="/images/welcomePage/wordIcon.svg" alt="modes" />
                      Add to Word
                    </Button>
                    <Button
                      onClick={() => selectClickHandler('chrome')}
                      className={` ${css.extBox} ${css.extBox2} ${classes.btnText}`}
                      variant="outlined"
                      color="primary"
                    >
                      <img
                        loading="lazy"
                        src="/images/theme/commonImages/chrome.png"
                        alt="chrome icon"
                      />
                      Add to Chrome
                    </Button>
                  </div>
                </Hidden>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
};

export default TryFeature;
